import React, { useEffect, useState } from 'react';
import { authFetch } from '../../lib/auth';
import { Card } from './os2ui';

/* Admin — every installed KITXENS Pixel across all clients, Cloudflare-style. */

const ago = (iso) => {
  if (!iso) return '—';
  const s = Math.max(1, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return `${s}s`;
  if (s < 3600) return `${Math.round(s / 60)}m`;
  if (s < 86400) return `${Math.round(s / 3600)}h`;
  return `${Math.round(s / 86400)}d`;
};

export default function AdminPixelsPanel({ isEs }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    const load = () => authFetch('/admin/pixels').then((r) => (r.ok ? r.json() : null)).then(setD).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, []);
  const rows = d?.pixels || [];
  return (
    <Card className="p-5 mt-3" data-testid="admin-pixels-panel">
      <h2 className="text-[14px] font-semibold tracking-tight">KITXENS Pixels</h2>
      <p className="text-[11px] text-gray-400">
        {isEs ? 'Todos los pixels instalados en clientes — conexión, eventos y salud en vivo.' : 'Every client-installed pixel — live connection, events and health.'}
      </p>
      {!rows.length && <p className="mt-3 text-[12px] text-gray-400">{isEs ? 'Aún no hay pixels reportando.' : 'No pixels reporting yet.'}</p>}
      {rows.length > 0 && (
        <div className="mt-3 overflow-x-auto">
          <table className="w-full text-left text-[11.5px]">
            <thead>
              <tr className="text-[9.5px] uppercase tracking-wider text-gray-400 border-b border-gray-100">
                <th className="py-1.5 pr-3">Pixel</th><th className="pr-3">{isEs ? 'Cliente' : 'Client'}</th>
                <th className="pr-3">{isEs ? 'Dominio' : 'Domain'}</th><th className="pr-3">{isEs ? 'Estado' : 'Status'}</th>
                <th className="pr-3">{isEs ? 'Última señal' : 'Last seen'}</th><th className="pr-3">{isEs ? 'Último evento' : 'Last event'}</th>
                <th className="pr-3">Ev/min</th><th className="pr-3">{isEs ? 'Hoy · 7d' : 'Today · 7d'}</th>
                <th className="pr-3">v</th><th className="pr-3">{isEs ? 'Errores' : 'Errors'}</th>
                <th className="pr-3">Lat</th><th className="pr-3">IP</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((p) => (
                <tr key={p.pixel_id} className="border-b border-gray-50 last:border-0" data-testid={`admin-pixel-${p.pixel_id}`}>
                  <td className="py-2 pr-3 font-mono font-bold text-gray-900">{p.pixel_id}</td>
                  <td className="pr-3 font-semibold text-gray-700">{p.restaurant || p.slug || '—'}</td>
                  <td className="pr-3 text-gray-500">{p.website || '—'}</td>
                  <td className="pr-3">
                    <span className={`inline-flex items-center gap-1.5 font-bold ${p.connected ? 'text-emerald-600' : 'text-gray-400'}`}>
                      <span className={`w-1.5 h-1.5 rounded-full ${p.connected ? 'bg-emerald-500 animate-pulse' : 'bg-gray-300'}`} />
                      {p.connected ? 'Online' : 'Offline'}
                    </span>
                  </td>
                  <td className="pr-3 tabular-nums text-gray-600">{ago(p.last_seen)}</td>
                  <td className="pr-3 text-gray-500">{p.last_event_type || '—'} <span className="text-gray-300">{ago(p.last_event_at)}</span></td>
                  <td className="pr-3 tabular-nums">{p.events_per_min}</td>
                  <td className="pr-3 tabular-nums">{(p.events_today ?? 0).toLocaleString()} · {(p.events_7d ?? 0).toLocaleString()}</td>
                  <td className="pr-3 font-mono text-gray-500">{p.version || '—'}</td>
                  <td className="pr-3 tabular-nums">{p.diagnostics?.js_errors ?? 0}</td>
                  <td className="pr-3 tabular-nums">{p.diagnostics?.latency_ms != null ? `${p.diagnostics.latency_ms}ms` : '—'}</td>
                  <td className="pr-3 font-mono text-gray-300">{(p.ip_hash || '').slice(0, 8) || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
